/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

let logoutTimer;

const initialState = {
  isLoggedIn: !!localStorage.getItem("token") && localStorage.getItem("expirationTime") !== null,
  token: localStorage.getItem("token"),
  userRole: localStorage.getItem("userRole"),
  email: localStorage.getItem("user_email"),
  name: localStorage.getItem("name"),
  expirationTime: localStorage.getItem("expirationTime"),
  isPlanExpired: localStorage.getItem("isPlanExpired"),
  accountId: localStorage.getItem("accountId"),
  apiKey: localStorage.getItem("apiKey"),
  apiSecret: localStorage.getItem("apiSecret"),
  phone: localStorage.getItem("phone"),
  logoUrl: localStorage.getItem("logoUrl"),
  isStudentPaid: localStorage.getItem("isStudentPaid"),
  fillForm: localStorage.getItem("fillForm"),
  tutorVerify: localStorage.getItem("tutorVerify"),
  paymentGateway: localStorage.getItem("paymentGateway"),
  stripeVerified: localStorage.getItem("stripeVerified"),
  razorpayVerified: localStorage.getItem("razorpayVerified"),
  isManualStudent: localStorage.getItem("isManualStudent"),
  isTutorMapped: localStorage.getItem("isTutorMapped"),
  isTrialUsed: localStorage.getItem("isTrialUsed"),
  notificationCount: localStorage.getItem("notificationCount"),
};
// isLoggedIn: !!localStorage.getItem('token')

const calculateRemainingTime = (expirationTime) => {
  const currentTime = new Date().getTime();
  const adjExpirationTime = new Date(expirationTime).getTime();

  const remainingDuration = adjExpirationTime - currentTime;

  return remainingDuration;
};

// const retrieveStoredToken = () => {
//   const storedToken = localStorage.getItem("token");
//   const storedExpirationDate = localStorage.getItem("expirationTime");

//   const remainingTime = calculateRemainingTime(storedExpirationDate);

//   if (remainingTime <= 3600) {
//     localStorage.removeItem("token");
//     localStorage.removeItem("expirationTime");
//     return null;
//   }

//   return {
//     token: storedToken,
//     duration: remainingTime,
//   };
// };

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setLogo(state, action) {
      localStorage.setItem("logoUrl", action.payload);
      state.logoUrl = action.payload;
    },
    setUsername(state, action) {
      localStorage.setItem("name", action.payload);
      state.name = action.payload;
    },
    setForm(state, action) {
      localStorage.setItem("fillForm", action.payload);
      state.fillForm = action.payload;
    },
    setVerifyStatus(state, action) {
      localStorage.setItem("tutorVerify", action.payload);
      state.tutorVerify = action.payload;
    },
    setIsTrialUsed(state, action) {
      localStorage.setItem("isTrialUsed", action.payload);
      state.isTrialUsed = action.payload;
    },
    login(state, action) {
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("userRole", action.payload.userRole);
      localStorage.setItem("expirationTime", action.payload.expirationTime);
      localStorage.setItem("isPlanExpired", action.payload.isPlanExpired);
      localStorage.setItem("name", action.payload.name);
      localStorage.setItem("email", action.payload.email);
      localStorage.setItem("accountId", action.payload.accountId);
      localStorage.setItem("apiKey", action.payload.apiKey);
      localStorage.setItem("apiSecret", action.payload.apiSecret);
      localStorage.setItem("phone", action.payload.phone);
      localStorage.setItem("paymentGateway", action.payload.paymentGateway);
      localStorage.setItem("stripeVerified", action.payload.stripeVerified);
      localStorage.setItem("razorpayVerified", action.payload.razorpayVerified);
      localStorage.setItem("isManualStudent", action.payload.isManualStudent);
      localStorage.setItem("isTutorMapped", action.payload.isTutorMapped);
      localStorage.setItem("isTrialUsed", action.payload.isTrialUsed);
      // localStorage.setItem("notificationCount", action.payload.notificationCount);
      state.isLoggedIn = !!action.payload.token;
      state.token = action.payload.token;
      state.userRole = action.payload.userRole;
      state.name = action.payload.name;
      state.email = action.payload.email;
      state.isPlanExpired = action.payload.isPlanExpired;
      state.accountId = action.payload.accountId;
      state.apiKey = action.payload.apiKey;
      state.apiSecret = action.payload.apiSecret;
      state.phone = action.payload.phone;
      state.paymentGateway = action.payload.paymentGateway;
      state.stripeVerified = action.payload.stripeVerified;
      state.razorpayVerified = action.payload.razorpayVerified;
      state.isManualStudent = action.payload.isManualStudent;
      state.isTutorMapped = action.payload.isTutorMapped;
      state.isTrialUsed = action.payload.isTrialUsed;
      // state.notificationCount = action.payload.notificationCount;
    },
    logout(state) {
      localStorage.removeItem("token");
      localStorage.removeItem("userRole");
      localStorage.removeItem("expirationTime");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      localStorage.removeItem("isPlanExpired");
      localStorage.removeItem("accountId");
      localStorage.removeItem("apiKey");
      localStorage.removeItem("apiSecret");
      localStorage.removeItem("phone");
      localStorage.removeItem("fillForm");
      localStorage.removeItem("tutorVerify");
      localStorage.removeItem("isStudentPaid");
      localStorage.removeItem("paymentGateway");
      localStorage.removeItem("stripeVerified");
      localStorage.removeItem("razorpayVerified");
      localStorage.removeItem("isManualStudent");
      localStorage.removeItem("isTutorMapped");
      localStorage.removeItem("isTrialUsed");
      localStorage.removeItem("notificationCount");
      state.token = "";
      state.isLoggedIn = false;
      state.userRole = "";
      state.accountId = "";
      state.apiKey = "";
      state.apiSecret = "";
      state.phone = "";
      state.name = "";
      state.email = "";
      state.isPlanExpired = "false";
      state.expirationTime = "";
      state.fillForm = false;
      state.tutorVerify = "";
      state.isStudentPaid = "true";
      state.paymentGateway = "";
      state.stripeVerified = "false";
      state.razorpayVerified = "false";
      state.isManualStudent = "false";
      state.isTutorMapped = "false";
      state.isTrialUsed = 0;
      state.notificationCount = 0;
    },
    updateIsPlanExpired(state, action) {
      localStorage.setItem("isPlanExpired", action.payload);
      state.isPlanExpired = action.payload;
    },
    updateTutorMapping(state, action) {
      localStorage.setItem("isTutorMapped", action.payload);
      state.isTutorMapped = action.payload;
    },
    updatePaymentMethod(state, action) {
      localStorage.setItem("paymentGateway", action.payload.paymentGateway);
      localStorage.setItem("stripeVerified", action.payload.stripeVerified);
      localStorage.setItem("razorpayVerified", action.payload.razorpayVerified);
      state.paymentGateway = action.payload.paymentGateway;
      state.stripeVerified = action.payload.stripeVerified;
      state.razorpayVerified = action.payload.razorpayVerified;
    },
    setZoomKeys(state, action) {
      localStorage.setItem("accountId", action.payload.accountId);
      localStorage.setItem("apiKey", action.payload.apiKey);
      localStorage.setItem("apiSecret", action.payload.apiSecret);
      state.accountId = action.payload.accountId;
      state.apiKey = action.payload.apiKey;
      state.apiSecret = action.payload.apiSecret;
    },
    setPhone(state, action) {
      localStorage.setItem("phone", action.payload);
      state.phone = action.payload;
    },
    setStudentPaidOrNot(state, action) {
      localStorage.setItem("isStudentPaid", action.payload);
      state.isStudentPaid = action.payload;
    },
    setNotificationCount(state, action) {
      localStorage.setItem("notificationCount", action.payload);
      state.notificationCount = action.payload;
    },
  },
});

export const loginSelector = (state) => state.login;

export const loginActions = loginSlice.actions;

export const logoutHandler = () => (dispatch) => {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
  }
  dispatch(loginActions.logout());
};

export const resetTimer = () => {
  const expirationTime = new Date(new Date().getTime() + 4 * 60 * 60 * 1000); // means 4 hours
  // const expirationTime = new Date(new Date().getTime() + 15 * 1000); // means 15 seconds
  localStorage.setItem("expirationTime", expirationTime.toISOString());
  const remainingTime = calculateRemainingTime(expirationTime.toISOString());
  // reset logoutTimer
  if (logoutTimer) {
    clearTimeout(logoutTimer);
  }
  return (dispatch) => {
    logoutTimer = setTimeout(() => {
      const now = new Date().getTime();
      let expirationTime2 = localStorage.getItem("expirationTime");
      expirationTime2 = new Date(expirationTime2).getTime();
      if (now > expirationTime2) {
        dispatch(logoutHandler());
      }
    }, remainingTime);
  };
};

export const loginHandler = (data) => {
  const expirationTime = new Date(new Date().getTime() + 4 * 60 * 60 * 1000); // means 4 hours
  // const expirationTime = new Date(new Date().getTime() + 15 * 1000); // means 15 seconds
  const remainingTime = calculateRemainingTime(expirationTime.toISOString());
  return (dispatch) => {
    logoutTimer = setTimeout(() => {
      dispatch(logoutHandler());
    }, remainingTime);
    // console.log(logoutTimer);
    dispatch(loginActions.login({ ...data, expirationTime: expirationTime.toISOString() }));
  };
};

export default loginSlice.reducer;
